module.exports = __webpack_public_path__ + "static/media/Background.5d628fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background.png
// module id = 176
// module chunks = 0